import React, { useState } from "react";
import { Division, RootProductId, User } from "@models";
import { formatName } from "@service/util";
import ModuleSettingConfiguration from "../../products/components/ModuleSettingConfiguration";
import { createDefaultModuleSetting } from "../../products/components/util";
import { useProduct } from "@hooks";
import { CommonModal } from "@components";

const MAX_EXPLICIT_USERS = 5;

type Props = {
	users: User[];
	productId: RootProductId;
	division: Division;
	onClose: () => void;
};

export default function BulkAddModuleSettings(props: Props) {
	const { users, productId, division, onClose } = props;
	const product = useProduct(productId);

	const [moduleSetting] = useState(
		createDefaultModuleSetting(
			product,
			users[0],
			undefined,
			division.categories
		)
	);
	const modelTitle = `Neue ${product.name}-Module anlegen`;

	return (
		<CommonModal handleClose={onClose} header={modelTitle}>
			<div>
				<span>
					{users.slice(0, MAX_EXPLICIT_USERS).map(formatName).join(", ")}
				</span>
				{users.length > MAX_EXPLICIT_USERS && (
					<span>und {users.length - MAX_EXPLICIT_USERS} weitere</span>
				)}
			</div>
			<ModuleSettingConfiguration
				onClose={onClose}
				moduleSetting={moduleSetting}
				users={users}
			/>
		</CommonModal>
	);
}
